// extracted by mini-css-extract-plugin
export default {"cards":"AssetHealthCards_cards__kUxeL"};